import { MetadataModules } from '../../enums/index.js';
import { tags as transferSyntaxTags } from './transferSyntax.js';
import { tags as cineTags } from './cine.js';
import { tags as ptIsotopeTags } from './ptIsotope.js';
import { tags as radiopharmaceuticalInfoTags } from './radiopharmaceuticalInfo.js';
import { tags as ptImageTags } from './ptImage.js';
import { tags as ptSeriesTags } from './ptSeries.js';
import { tags as patientTags } from './patient.js';
import { tags as patientStudyTags } from './patientStudy.js';
import { tags as generalStudyTags } from './generalStudy.js';
import { tags as generalSeriesTags } from './generalSeries.js';
import { tags as clinicalTrialTags } from './clinicalTrial.js';
import { tags as sopCommonTags } from './sopCommon.js';
import { tags as ecgTags } from './ecg.js';
import { tags as generalImageTags } from './generalImage.js';
import { tags as imagePlaneTags } from './imagePlane.js';
import { tags as imagePixelTags } from './imagePixel.js';
import { tags as voiLutTags } from './voiLut.js';
import { tags as modalityLutTags } from './modalityLut.js';
import { tags as ultrasoundEnhancedRegionTags } from './ultrasoundEnhancedRegion.js';
import { tags as usRegionChildTags } from './usRegionChild.js';
import { tags as unassignedTags } from './unassigned.js';
export const USRegionChild = 'usRegionChild';
export const CLINICAL_TRIAL = 'clinicalTrialModule';
export const RadiopharmaceuticalInfoModule = 'RadiopharmaceuticalInfo';
export const moduleDefinitions = [
    [MetadataModules.TRANSFER_SYNTAX, transferSyntaxTags],
    [MetadataModules.CINE, cineTags],
    [MetadataModules.PET_ISOTOPE, ptIsotopeTags],
    [RadiopharmaceuticalInfoModule, radiopharmaceuticalInfoTags],
    [MetadataModules.PET_IMAGE, ptImageTags],
    [MetadataModules.PET_SERIES, ptSeriesTags],
    [MetadataModules.PATIENT, patientTags],
    [MetadataModules.PATIENT_STUDY, patientStudyTags],
    [MetadataModules.GENERAL_STUDY, generalStudyTags],
    [MetadataModules.GENERAL_SERIES, generalSeriesTags],
    [CLINICAL_TRIAL, clinicalTrialTags],
    [MetadataModules.SOP_COMMON, sopCommonTags],
    [MetadataModules.ECG, ecgTags],
    [MetadataModules.GENERAL_IMAGE, generalImageTags],
    [MetadataModules.IMAGE_PLANE, imagePlaneTags],
    [MetadataModules.IMAGE_PIXEL, imagePixelTags],
    [MetadataModules.VOI_LUT, voiLutTags],
    [MetadataModules.MODALITY_LUT, modalityLutTags],
    [MetadataModules.ULTRASOUND_ENHANCED_REGION, ultrasoundEnhancedRegionTags],
    [USRegionChild, usRegionChildTags],
    [null, unassignedTags],
];
